import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function CollapsibleCitation({
  /* title_citation, */
  source,
  fullCitation,
  color = "#fff"
}) {
  return (
    <Accordion
      elevation={0}
      square
      sx={{
        background: "transparent",
        color: "rgba(255,255,255,0.8)",
        "& .MuiAccordionSummary-root": { padding: 0, marginTop: 0 },
        "& .MuiAccordionDetails-root": { padding: 0, marginTop: -1 }
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: color }} />}>
        <Typography className="text-sm" variant="body2" color={color}>
          {/* <strong>{title_citation}</strong> — {source} */}
          <strong>Source: {source} </strong>
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography className="text-sm" variant="caption" color={color} sx={{ display: "block", mt: -2 }}>
          {fullCitation}
        </Typography>
      </AccordionDetails>
    </Accordion>
  );
}